import { Injectable } from '@angular/core';
import {
  CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree,
  Router
} from '@angular/router';
// @ts-ignore
import { Observable } from 'rxjs';
import { TokenService } from '../services/app-services/token.service';
import {CUSTOM_CONSTANTS} from '../utilities/config';
import {Session} from '../utilities/session';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private _router: Router, private _tokenService: TokenService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._tokenService.isTokenLogged()) {
      return true;
    } else {
      const viewDoc = localStorage.getItem('VIEW_DOCUMENT');
      if(!viewDoc && state.url.includes('/files/document/') && state.url.includes('/view-details')) {
        localStorage.setItem('VIEW_DOCUMENT', window.location.href);
      }
      setTimeout(() => {
        this._tokenService.logoutToken(state.url);
        this._router.navigate(['login']);
      }, 200);
      return false;
    }
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._tokenService.isTokenLogged()) {
      return this._tokenService.isTokenLogged();
    } else {
      this._tokenService.logoutToken();
      this._router.navigate(['login']);
      return false;
    }
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (this._tokenService.isTokenLogged()) {
      return true;
    } else {
      this._tokenService.logoutToken();
      this._router.navigate(['login']);
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class RoleService implements CanActivate {
  static getAuthUser() {
    // return JSON.parse(sessionStorage.getItem(ENV.USERTOKEN));
    return Session.get(CUSTOM_CONSTANTS.APP_VARIABLE);

  }
  static checkRole(roles): boolean {
    if (!roles.length) { return false; }
    const user = RoleService.getAuthUser();
    const userRole = user && user.role.toLowerCase();
    return (userRole === 'super admin' && roles.includes('super admin') && roles[0] === 'super admin');
  }
  constructor( ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const roles: any = route.data;
    // console.log('ROLE DATA ', roles);
    return RoleService.checkRole(roles.roles);
  }
}
